/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
import { assign, createMachine, sendParent } from 'xstate-v4'

type FavouriteWishlistEvents =
  | { type: 'SAVE_TO_WISHLIST' }
  | { type: 'REMOVE_FROM_WISHLIST' }
  | { type: 'UPDATE_NOTE'; note: string }

export type FavouriteWishlistContext = {
  note: string
  id: string
  campsiteId: string
  hasCampsite: boolean
  itemCount: number
}

export function getFavouriteWishlistMachine(
  favStore: ReturnType<typeof useFavouritesStore>,
) {
  // Define the wishlist element machine
  return createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QHcCWsAWAbdAXAolmALZgB2uAdKmarqgIZYDEA2gAwC6ioADgPaw6qfmR4gAHogCMAZgCslaewCcsgOztl7AGwrpKgDQgAnogAs0gByUdd9QCY9Knevkr1sgL5fjaTDiwBESkFNS09Exs0txIIAJC9KLiUghyispqmtp6BsZmCFbSlPLsZVryDm465uoqPn7o2HiEJORUZPy4AJJkAOpNgbjMAMoAggBq+AD6ACoA8tN93SMAEgAyK7McsXyCwslxqdJ15pSy7HXq1+py+rL5iCrm7JTqVuY6srWfVnZWDRA-maQVaoQ6XV6AwCeEosAYADcaFBZvxoSDhhBRGBwgj+ABrHHAoZg9qUTo9fqDWHwpFkFFo6lBBA0PEAYwYSTIOx24gSBzER0QlUeCB00h0lGeZRUVl013MKgcgOJLRCZIpUKZVFpyNR6KGzDAACdjfxjZReFhOQAzc3ESiq0HqsKaqkwoJwxF6xke3AssjszkiblcXlxflclLChyipXFKxqBRqGoOBzyAG+IHa0lhGgGvDMABK+AAsvMptMAGJF+alpYrDZbcN7RIh6MIBwqFRvFxWW6yKrscyJnSi8wOGz6VyyD7mC7i5VZp3BNp590Y5gAVQACgARMazGYAOXmR5b8X2UaFne7vZ0-bkQ5HLlFVRslW+dnYg-7spVOYulQ+bapQxokPwdJQFWZrEAWQTMFiZA4qyBJEoBa7ARuQxgRBUEwfwcHagGQZcjyXB8le7Y3nIfxSvIFxqFYzEpmOpgWGmbyeIqD6JsxqgAX6uZYfBVDgcQkHIgRRF+kaprmpa1q4HaxoOiuwnhKJuESfhsGiSR-AcmRYYURGVGHKAqTyLcSi3H83aOOY8gPqKsgPiUZTSOmlwZo4OiCRiGkgX6lAAK68BAwb0qJe5gAARvwoVkGyYDMBIQScjiDA2rgJoABQOOUACUzDqUBmmgeFkX0NF2qxQlSUpRekbUZZiBFA45yTncpwqJU0iuewnVuGUtTqOKcj+cuGHghVIVVVFUCiYh2K4mhjozWSwUYmFEWLfpqFGSG5G7JebYWZIMjSNZlBdg+41-BO1hsQUTg9qUZQKBcuifOoAUkuV204QtNVLdqclmhaVq2vaG1CYD2GwiDyIHYGhnBqIJ2UedgptWk13qLdfYPamz2uSclDlMO426M5S5Zp0EBwOIZWYdjAodgAtC9iDc5TVNWPII6PW58j-WqmHhMITDs9eeMTuOygeWUbgeP2tPi86ktuqJsutZdaTqJ85yXB4Nx3HIoqnG8Hw6Bm86yCcs6a6us066BqAQEQesXccguyJQiayC4Dhee8P6xuxhRWJ1k6fO4LiXLOU2NPD2uQojnq6vS+raj7uMG4VQ2ULU3ZDVYCiC1UcYU+8v1OB8b0p9maezUDeD5x26bFHU91PpoL482kMf81Tbl6Bc5gu0FmfAV7YCdzes4B4mugOLIs4VP246JiXEoDmm+iJmL02t1ts-aZJ9LSbrZk4x2dvFM5pTdXYbl-OOhXK5cuiXF8TjTwRlpZGtU-T1USslBed8OY3nkM5KUHxRYnAMBXIwUcLg9w+oqGORsVDykAZLdunoQFgz9IvPGahFA6FUJYDeE4k5D3fLdD6QsNDvAJgQ2aJpIbkMLqUSmjsnB1EqG4W4Q8lSvCDt8WoGhhwSh8D4IAA */
      id: 'wishlistElement',
      initial: 'initial',
      schema: {
        context: {} as FavouriteWishlistContext,
        events: {} as FavouriteWishlistEvents,
      },
      context: {
        note: '',
      },
      states: {
        initial: {
          always: [
            {
              target: 'inWishlist',

              cond: (c) => c.hasCampsite,
            },
            {
              target: 'notInWishlist',
            },
          ],
        },
        notInWishlist: {
          tags: ['notInWishlist'],
          initial: 'idle',
          on: {
            SAVE_TO_WISHLIST: '.savingToWishlist',
          },
          states: {
            idle: {},
            savingToWishlist: {
              // TODO: send event to paretn
              invoke: {
                src: 'saveToWishlist',
                onDone: {
                  target: '#wishlistElement.savedToWishlist',
                  actions: assign({
                    hasCampsite: true,
                    itemCount: (c) => c.itemCount + 1,
                  }),
                },
                onError: '#wishlistElement.error',
              },
            },
          },
        },
        savedToWishlist: {
          entry: sendParent((context) => ({
            type: 'UPDATE_CHANGE',
            listId: context.id,
            isSaved: true,
          })),
          after: {
            1: 'inWishlist',
          },
        },
        removedFromWishlist: {
          entry: sendParent((context) => ({
            type: 'UPDATE_CHANGE',
            listId: context.id,
            isSaved: false,
          })),
          after: {
            1: 'notInWishlist',
          },
        },
        inWishlist: {
          tags: ['inWishlist'],
          initial: 'idle',
          on: {
            REMOVE_FROM_WISHLIST: {
              target: '.removingFromWishlist',
            },
            UPDATE_NOTE: {
              target: '.updatingWishlistDebounce',
              actions: ['updateNote'],
            },
          },
          states: {
            idle: {},
            removingFromWishlist: {
              // TODO: send event to paretn
              invoke: {
                src: 'removeFromWishlist',
                onDone: {
                  target: '#wishlistElement.removedFromWishlist',
                  actions: assign({
                    hasCampsite: false,
                    itemCount: (c) => c.itemCount - 1,
                  }),
                },
                onError: '#wishlistElement.error',
              },
            },
            updatingWishlistDebounce: {
              on: {
                UPDATE_NOTE: {
                  target: 'updatingWishlistDebounce',
                  actions: ['updateNote'],
                },
              },
              after: {
                500: 'updatingWishlist',
              },
            },
            updatingWishlist: {
              // TODO: send event to paretn
              invoke: {
                src: 'updateWishlist',
                onDone: '#wishlistElement.inWishlist',
                onError: '#wishlistElement.inWishlist',
              },
            },
          },
        },
        error: {},
      },
    },
    {
      services: {
        updateWishlist: async ({ id, campsiteId, note }: any) => {
          return await favStore.updateFavouriteNoteInWishlist(
            id,
            campsiteId,
            note,
          )
        },
        saveToWishlist: async ({ id, campsiteId }: any) => {
          return await favStore.addFavouriteToWishlist(id, campsiteId)
        },
        removeFromWishlist: async ({ id, campsiteId }: any) => {
          return await favStore.removeFavouriteFromWishlist(id, campsiteId)
        },
      },
      actions: {
        updateNote: assign({
          note: (_, event) => {
            if (event.type === 'UPDATE_NOTE') {
              return event.note
            }
            return ''
          },
        }),
      },
    },
  )
}
